import * as styles from './styles';
import { translate } from 'react-i18next';

export default translate()(
  ({
    i18n,
    input,
    label,
    placeholder,
    isRequired,
    disabled,
    notification,
    style,
    commonError,
    optional,
    meta: { touched, error, active } = {}
  }) => (
    <div style={style}>
      {/* Label */}

      <styles.InputLabel className="input-label">
        {label}
        {optional && (
          <styles.Optional>
            {' '}
            ({i18n.t('optional_title_postfix')})
          </styles.Optional>
        )}
        {isRequired && <styles.Required> *</styles.Required>}
      </styles.InputLabel>

      {/* Text Area */}
      <styles.TextArea
        {...input}
        placeholder={placeholder}
        disabled={disabled}
        active={active}
        error={commonError || (error && touched)}
      />
      {/* Errors */}

      {touched &&
        error && (
        <styles.ErrorMessage className="input-field-error">
          {typeof error === 'string' && i18n.t(error)}
        </styles.ErrorMessage>
      )}

      {/* Notification */}

      {notification && (
        <styles.InputNotification>{notification}</styles.InputNotification>
      )}
    </div>
  )
);
